import React from "react"
import Layout from "../../layouts/Layout"
import Header from "../../components/Header"
import BlogCard from "../../components/BlogCard"
import { graphql } from "gatsby"


export default function Blogs({data}) {
  const blogs = data.allMarkdownRemark.nodes
  console.log(data)
  return (
    <Layout>
      <Header heading={"BLOGS"} subHeading={""}></Header>
      <section>
        {/* <h1 className="heading">Events</h1> */}
        {/* <h3 className="sub-heading">All Events</h3> */}
        <div className="container">
        {blogs.map(blog => (
            <BlogCard title = {blog.frontmatter.title} author= {blog.frontmatter.author} slug = {blog.frontmatter.slug} thumb = {blog.frontmatter.thumb.childImageSharp.fluid}/>
          ))}
          
        </div>
        </section>



      <div className="seperator"></div> 
    </Layout>

  )
}

//export event queries
export const query = graphql`query BlogQuery {
  allMarkdownRemark(
    sort: {order: ASC, fields: frontmatter___sortBy}
    filter: {fileAbsolutePath: {regex: "/(blogs)/"}}
  ) {
    nodes {
      frontmatter {
        title
        author
        slug
        thumb {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      id
    }
  }
}
`